import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import Reserveren from "@/pages/Reserveren";
import Bevestiging from "@/pages/Bevestiging";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reserveren" element={<Reserveren />} />
          <Route path="/reserveren/bevestiging" element={<Bevestiging />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/aanvragen" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
